import CustomPopup from '@/components/customPopup/CustomPopup';
import { SchedulePopUpInterface } from '../../SchedulingInterface';
import { useTranslation } from 'react-i18next';
import WhatsappIllustration from '@/assets/whatsapp_illustration.svg';

export const WhatsappPopUp = ({
  showPopUp,
  setShowPopUp,
  buttonActionArray,
}: SchedulePopUpInterface) => {
  const { t } = useTranslation('whatsAppPopup');
  return (
    <CustomPopup
      title={t('whatsAppPopup_title')}
      description={t('whatsAppPopup_description')}
      popupHidden={!showPopUp}
      imageHidden={false}
      image={WhatsappIllustration}
      closeHidden
      closeAction={() => setShowPopUp(false)}
      buttonTitleArray={[
        t('whatsAppPopup_stay_here'),
        t('whatsAppPopup_go_to_whatsapp'),
      ]}
      buttonOnlyTextArray={[false, true]}
      buttonOutlinedArray={[false, true]}
      buttonColorArray={['error', 'error']}
      buttonActionArray={buttonActionArray ?? []}
    />
  );
};
